module.exports = __webpack_public_path__ + "static/media/audience.c8e5fc29.svg";